export default "__VITE_ASSET__N5EaDPjV__"